import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import i18next from 'i18next';
import { call } from 'redux-saga/effects';
import { requestPuppy, isApiError } from '@wix/da-http-client/pkg/request';
import { putErrorNotification } from '../../utils/saga';
let fakeCollections = [];
function getFakeCollections() {
    if (process.env.NODE_ENV !== 'production') {
        const collections = // eslint-disable-next-line global-require
        require('@wix/da-sample-data').collections;
        // move Featured folder to first
        let featured = null;
        const nonFeatured = [];
        for (const collection of collections){
            if (collection.name === 'Featured') {
                featured = collection;
            } else {
                nonFeatured.push(collection);
            }
        }
        // duplicate non-featured so we can get some pagination
        // but randomize ids so the collections aren't deduped in the Stream
        const additionalCollections = [
            ...nonFeatured,
            ...nonFeatured,
            ...nonFeatured
        ].map((c)=>_object_spread_props(_object_spread({}, c), {
                folderId: Math.floor(Math.random() * 1000)
            }));
        fakeCollections = [
            ...featured ? [
                featured
            ] : [],
            ...nonFeatured,
            ...additionalCollections
        ];
    }
    return fakeCollections;
}
export function* doFetchCollections(isPrivateCollections, offset = 0, limit = 20) {
    const params = {
        type: isPrivateCollections ? 'private_collection' : 'collection',
        offset,
        limit
    };
    const result = yield call(requestPuppy, {
        method: 'get',
        url: 'gallection/folders',
        params
    }, ()=>{
        const collections = getFakeCollections();
        const nextOffset = offset + limit;
        const hasMore = collections.length - 1 > nextOffset;
        return {
            hasMore,
            nextOffset: hasMore ? nextOffset : null,
            results: collections.slice(offset, nextOffset)
        };
    });
    return result;
}
export function* doFetchContainingCollectionIds(deviationId, isPrivateCollections) {
    const params = {
        deviationid: deviationId
    };
    const url = isPrivateCollections ? 'privatecollections/collections_for_deviation' : 'collections/collections_for_deviation';
    const result = yield call(requestPuppy, {
        method: 'get',
        url,
        params
    }, ()=>{
        const res = {
            collectionIds: []
        };
        return res;
    });
    return result && result.collectionIds;
}
export function* doCommitCollections(folderIds, deviationId, isPrivateCollections) {
    const data = {
        itemid: deviationId,
        folderids: folderIds
    };
    const url = isPrivateCollections ? 'privatecollections/collect' : 'collections/collect';
    const result = yield call(requestPuppy, {
        method: 'post',
        url,
        data
    }, ()=>({
            success: true
        }));
    return result;
}
export function* doCreateCollection(name, isPrivateCollections) {
    const data = {
        name,
        type: isPrivateCollections ? 'private_collection' : 'collection'
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'gallection/folders/create',
        data
    }, ({ data: { name: fakeName } })=>({
            success: true,
            gallection: _object_spread_props(_object_spread({}, getFakeCollections()[0]), {
                folderId: Math.round(Math.random() * 100000),
                name: fakeName
            })
        }));
    if (isApiError(result)) {
        const { errorDescription } = result;
        yield putErrorNotification(i18next.t('collectionPanel.error.newCollection', {
            errorDescription
        }));
        return;
    }
    return result || {
        success: false
    };
}
export function* doFave(deviationId) {
    const data = {
        itemid: deviationId
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'collections/fave',
        data
    }, ()=>({
            success: true
        }));
    return result || {
        success: false
    };
}
export function* doUnfave(deviationId) {
    const data = {
        itemid: deviationId
    };
    const result = yield call(requestPuppy, {
        method: 'post',
        url: 'collections/unfave',
        data
    }, ()=>({
            success: true
        }));
    return result || {
        success: false
    };
}
